import React from 'react';
import { RadioButton } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { OptionLabel, OptionWrap } from './Option';
import { getNestedInputName } from '../nested-input/getNestedInputName';
import { INestedInputLevel } from '../nested-input/INestedInputLevel';
import { useExtrasFormContext } from '../helpers/useExtrasFormContext';
import { Path } from 'react-hook-form';
import { IExtrasFormData } from '../IExtrasFormData';

interface IOptionBlankProps {
	nestedInputLevel: INestedInputLevel;
}

export const OptionBlank = ({ nestedInputLevel }: IOptionBlankProps) => {
	const { register } = useExtrasFormContext();
	const { t } = useTranslation();

	const name = getNestedInputName(
		nestedInputLevel,
		'selected',
	) as Path<IExtrasFormData>;

	return (
		<OptionWrap>
			<RadioButton
				value=""
				label={<OptionLabel name={t('parking_booking_extras_no_thanks')} />}
				defaultChecked
				{...register(name)}
			/>
		</OptionWrap>
	);
};
